module.exports = __webpack_public_path__ + "static/media/dot-preloader.867c7774.svg";